module.exports = __webpack_public_path__ + "static/media/employment-details.37af4a6f.svg";